/* ============
 * Mutation types for the organisations module
 * ============
 *
 * The mutation types that are available
 * on the organisations module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({
  FETCH_ORGANISATIONS: null,
  FETCH_ORGANISATIONS_SUCCESS: null,
  FETCH_ORGANISATIONS_FAIL: null
});
